// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"c1b30e72dd1c97ef80cb","678":"59c54efcd0e414df42a9"}[chunkId] + ".js";
};